import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Header from "@/components/landing/Header";
import Hero from "@/components/landing/Hero";
import Services from "@/components/landing/Services";
import Problem from "@/components/landing/Problem";
import LeadForm from "@/components/landing/LeadForm";
import Footer from "@/components/landing/Footer";

const Landing = () => (
  <div className="min-h-screen bg-stone-50">
    <Header />
    <main>
      <Hero />
      <Services />
      <Problem />
      <LeadForm />
    </main>
    <Footer />
  </div>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
